import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Check localStorage first - supports 'classic' or 'modern'
    const saved = localStorage.getItem('theme');
    if (saved === 'modern' || saved === 'classic') return saved;
    // Migrate old values
    if (saved === 'professional') return 'modern';
    if (saved === 'light') return 'classic';
    return 'classic'; // Default to classic
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    // Apply theme attribute to document for CSS targeting
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
    // Remove old dark class if present
    root.classList.remove('dark');
  }, [theme]);

  const setClassic = () => setTheme('classic');
  const setModern = () => setTheme('modern');

  const isModern = theme === 'modern';
  const isClassic = theme === 'classic';

  return (
    <ThemeContext.Provider value={{ theme, setClassic, setModern, isModern, isClassic }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
